import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import withMainControls from 'eventbrite_design_system/structure/hoc/withMainControls';

import {
    location as locationDuck,
} from '@eb/destination-utils';

import SearchBaseScreen from '../components/SearchBaseScreen';
import {
    trackEventClickInternal as trackEventClickInternalAction,
    trackPageView as trackPageViewAction,
} from '../actions/analytics';
import {
    saveEvent as saveEventAction,
} from '../actions/event';
import {
    setSearchInformationFromUrl as setSearchInformationFromUrlAction,
} from '../actions/location';
import {
    handleApplyFilter as handleApplyFilterAction,
    handleRemoveFilter as handleRemoveFilterAction,
    updateSearchInformationFromUrl as updateSearchInformationFromUrlAction,
} from '../actions/search';

const {
    actions: {
        updateLocation: updateLocationAction,
    },
} = locationDuck;

const _mapStateToProps = (state) => ({
    domain: state.app.domain,
    isAuthenticated: state.auth.isAuthenticated,
    currentPlace: state.location.currentPlace,
    currentPlaceParent: state.location.currentPlaceParent,
    placeType: state.location.placeType,
    isGoogleLocationAutocompleteEnabled: state.app.featureFlags.isGoogleLocationAutocompleteEnabled,
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleApplyFilter: (...args) => dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleRemoveFilter: (...args) => dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
    onSaveEvent: (...args) => dispatch(saveEventAction(...args)),
    updateLocation: (...args) => dispatch(updateLocationAction(...args)),
    setSearchInformationFromUrl: (...args) => dispatch(setSearchInformationFromUrlAction(...args)),
    updateSearchInformationFromUrl: (...args) => dispatch(updateSearchInformationFromUrlAction(...args)),
    trackEventClickInternal: (...args) => dispatch(trackEventClickInternalAction(...args)),
    onTrackPageViewAction: (...args) => dispatch(trackPageViewAction(...args)),
});

export default withMainControls(withRouter(connect(
    _mapStateToProps,
    _mapDispatchToProps
)(SearchBaseScreen)));
